/* GoBuildIt — gbi-core.js (spec v2 §B1.3, §C.4)
   window.GBI: config, strings, t(), money, track, cart, dialog, shared drawer, count-up.
   Vanilla ES2019, one IIFE, no globals other than window.GBI and window.__gbiCore. */
(function () {
  'use strict';
  if (window.__gbiCore) return;
  window.__gbiCore = true;

  var doc = document;
  var root = doc.documentElement;

  /* ------------------------------------------------------------------ utils */

  // English fallbacks, used only when the section setting is missing.
  var FALLBACK_STRINGS = {
    close: 'Close',
    cartError: 'Something went wrong. Please try again.',
    adding: 'Adding…',
    soldOut: 'Sold out',
    unavailable: 'Unavailable',
    kitsOne: '1 kit',
    kitsMany: '[n] kits'
  };

  var DEFAULT_ROUTES = {
    root: '/',
    cart: '/cart',
    cartAdd: '/cart/add',
    cartChange: '/cart/change',
    cartUpdate: '/cart/update',
    recommendations: '/recommendations/products'
  };

  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; }
  }

  function emit(target, name, detail) {
    try {
      target.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
    } catch (e) { /* never break the caller */ }
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, Math.max(0, ms || 0)); });
  }

  function tokenMs(name, fallback) {
    var raw = '';
    try { raw = getComputedStyle(root).getPropertyValue(name).trim(); } catch (e) { raw = ''; }
    if (!raw) return fallback;
    var n = parseFloat(raw);
    if (!isFinite(n)) return fallback;
    return /ms$/.test(raw) ? n : (/s$/.test(raw) ? n * 1000 : n);
  }

  function slowMs() {
    if (mq.reduced && mq.reduced.matches) return 0;
    return tokenMs('--gbi-dur-slow', 280);
  }

  function decodeEntities(str) {
    if (!/[&<]/.test(str)) return str;
    var noTags = String(str).replace(/<[^>]*>/g, '');
    var ta = doc.createElement('textarea');
    ta.innerHTML = noTags;
    return ta.value;
  }

  /* ------------------------------------------------------- config, strings */

  var mq = {
    desktop: window.matchMedia('(min-width: 990px)'),
    reduced: window.matchMedia('(prefers-reduced-motion: reduce)')
  };

  var config = { routes: Object.assign({}, DEFAULT_ROUTES), moneySample: '', currency: '', locale: 'en', designMode: false };
  var strings = Object.assign({}, FALLBACK_STRINGS);

  function loadConfig() {
    var g = readJSON(doc.querySelector('script[data-gbi-global]'));
    if (g && typeof g === 'object') {
      var routes = Object.assign({}, DEFAULT_ROUTES);
      if (g.routes && typeof g.routes === 'object') {
        Object.keys(g.routes).forEach(function (k) { if (g.routes[k]) routes[k] = g.routes[k]; });
      }
      Object.keys(g).forEach(function (k) { if (k !== 'routes') config[k] = g[k]; });
      config.routes = routes;
      config.designMode = !!g.designMode;
    }
    var s = readJSON(doc.querySelector('script[data-gbi-strings]'));
    Object.keys(FALLBACK_STRINGS).forEach(function (k) {
      var v = s && typeof s[k] === 'string' ? s[k].trim() : '';
      strings[k] = v || FALLBACK_STRINGS[k];
    });
    if (s && typeof s === 'object') {
      Object.keys(s).forEach(function (k) {
        if (!(k in FALLBACK_STRINGS) && typeof s[k] === 'string' && s[k].trim()) strings[k] = s[k];
      });
    }
    moneyCache = null;
  }

  /* ---------------------------------------------------------- t, handleize */

  function t(str, vars) {
    var v = vars || {};
    return String(str == null ? '' : str).replace(/\[([A-Za-z0-9_]+)\]/g, function (m, key) {
      return Object.prototype.hasOwnProperty.call(v, key) && v[key] != null ? String(v[key]) : m;
    });
  }

  var NON_ALNUM;
  try { NON_ALNUM = new RegExp('[^\\p{L}\\p{N}]+', 'gu'); } catch (e) { NON_ALNUM = /[^a-z0-9]+/g; }

  function handleize(str) {
    return String(str == null ? '' : str)
      .toLowerCase()
      .trim()
      .replace(NON_ALNUM, '-')
      .replace(/^-+|-+$/g, '');
  }

  /* ------------------------------------------------------------------ money */

  var moneyCache = null;
  var moneyCacheSample = null;

  function parseMoneySample(sample) {
    var s = decodeEntities(String(sample || ''));
    var m = /\d[\d.,'\s  ]*\d/.exec(s);
    if (!m) return null;
    var num = m[0];
    var out = {
      prefix: s.slice(0, m.index),
      suffix: s.slice(m.index + num.length),
      decimal: '',
      decimals: 0,
      thousands: ''
    };
    var dm = /([.,])\d{2}$/.exec(num);
    var intPart = num;
    if (dm) {
      out.decimal = dm[1];
      out.decimals = 2;
      intPart = num.slice(0, num.length - 3);
    }
    var tm = /\D/.exec(intPart);
    if (tm && tm[0] !== out.decimal) out.thousands = tm[0];
    return out;
  }

  function formatMoney(cents) {
    var n = Math.round(Number(cents));
    if (!isFinite(n)) n = 0;
    if (moneyCache === null || moneyCacheSample !== config.moneySample) {
      moneyCacheSample = config.moneySample;
      moneyCache = parseMoneySample(config.moneySample) || false;
    }
    var f = moneyCache;
    if (!f) {
      try {
        return new Intl.NumberFormat(config.locale || undefined, { style: 'currency', currency: config.currency || 'EUR' }).format(n / 100);
      } catch (e) {
        return (n / 100).toFixed(2);
      }
    }
    var neg = n < 0;
    var abs = Math.abs(n);
    var whole, frac = '';
    if (f.decimals === 2) {
      whole = Math.floor(abs / 100);
      frac = String(abs % 100);
      if (frac.length < 2) frac = '0' + frac;
    } else {
      whole = Math.floor((abs + 50) / 100); // round half up
    }
    var intStr = String(whole);
    if (f.thousands) intStr = intStr.replace(/\B(?=(\d{3})+(?!\d))/g, f.thousands);
    return (neg ? '-' : '') + f.prefix + intStr + (f.decimals === 2 ? f.decimal + frac : '') + f.suffix;
  }

  /* -------------------------------------------------------- track, onIdle */

  function track(event, params) {
    if (!event) return;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: String(event) }, params || {}));
    } catch (e) { /* ignore */ }
    try {
      if (typeof window.clarity === 'function') window.clarity('event', String(event));
    } catch (e) { /* ignore */ }
  }

  function onIdle(fn) {
    if (typeof fn !== 'function') return;
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 3000 });
    else setTimeout(fn, 1500);
  }

  /* ------------------------------------------------------------------- cart */

  function cartRoute() { return config.routes.cart || '/cart'; }

  function themeDrawer() { return doc.querySelector('cart-drawer'); }

  function sectionIdsFor(d) {
    var ids = null;
    if (d && typeof d.getSectionsToRender === 'function') {
      try {
        ids = d.getSectionsToRender().map(function (s) { return s && s.id; }).filter(Boolean);
      } catch (e) { ids = null; }
    }
    return ids && ids.length ? ids : ['cart-drawer', 'cart-icon-bubble'];
  }

  function mergeItems(items) {
    var map = {};
    var order = [];
    (Array.isArray(items) ? items : []).forEach(function (it) {
      if (!it) return;
      var id = Number(it.id);
      var q = Math.floor(Number(it.quantity));
      if (!id || !isFinite(id) || !isFinite(q)) return;
      if (!map[id]) { map[id] = { id: id, quantity: 0 }; order.push(id); }
      map[id].quantity += q;
    });
    return order.map(function (id) { return map[id]; }).filter(function (it) { return it.quantity >= 1; });
  }

  function cartGet() {
    return fetch(cartRoute() + '.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error(strings.cartError);
      return res.json();
    });
  }

  function kitsIn(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (sum, item) {
      var price = Number(item && item.price);
      var line = item && item.final_line_price;
      // €0 gift lines are not kits (price 0, or a line discounted to 0)
      if (!(price > 0) || line === 0) return sum;
      return sum + (Number(item.quantity) || 0);
    }, 0);
  }

  function fetchSections(ids) {
    return fetch(cartRoute() + '?sections=' + ids.join(','), {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('sections ' + res.status);
      return res.json();
    });
  }

  function focusDrawerInner(d) {
    var target = d.querySelector('.drawer__inner') || d;
    if (!target.hasAttribute('tabindex') && !target.matches('a[href], button, input, select, textarea')) {
      target.setAttribute('tabindex', '-1');
    }
    try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
  }

  function cartDrawerActive(d) { return !!(d && d.classList.contains('active')); }

  // PICK-4 / V3D-2: after a gbi add, other scripts (BOGOS renderCartDefaultTheme)
  // call renderContents too, which drops focus to <body>. While the guard is
  // armed and the drawer is open, any drawer re-render that leaves focus on
  // <body> puts it back on .drawer__inner. setActiveElement is never called, so
  // closing still returns focus to the opener.
  var focusGuard = null;
  function guardDrawerFocus(d, ms) {
    if (focusGuard) focusGuard.stop();
    if (!d || typeof MutationObserver === 'undefined') return;
    var timer = null;
    var mo = new MutationObserver(function () {
      if (!cartDrawerActive(d)) return;
      var a = doc.activeElement;
      if (!a || a === doc.body || a === doc.documentElement) focusDrawerInner(d);
    });
    function stop() {
      mo.disconnect();
      if (timer) clearTimeout(timer);
      timer = null;
      if (focusGuard === g) focusGuard = null;
    }
    mo.observe(d, { childList: true, subtree: true });
    timer = setTimeout(stop, ms || 8000);
    var g = { stop: stop };
    focusGuard = g;
  }

  function refresh(opts) {
    var open = !!(opts && opts.open);
    var d = themeDrawer();
    if (!d || typeof d.renderContents !== 'function') return Promise.resolve();
    var ids = sectionIdsFor(d);
    return fetchSections(ids).then(function (sections) {
      // PICK-4 (v3 §2.6.1): renderContents replaces the drawer's inner HTML and
      // drops focus to <body>. Keep focus inside the drawer; never call
      // setActiveElement here so closing still returns focus to the opener.
      // V3D-2: focus may already have dropped to <body> (BOGOS rendered first),
      // so an open drawer counts as "had focus" too.
      var before = doc.activeElement;
      var had = d.contains(before) || (cartDrawerActive(d) && (!before || before === doc.body));
      try { d.renderContents({ sections: sections }, !open); } catch (e) { /* keep page alive */ }
      if (had) {
        var active = doc.activeElement;
        if (!active || active === doc.body || !d.contains(active)) focusDrawerInner(d);
      }
    }).catch(function () { /* silent */ });
  }

  // BOGOS re-render (§C.4 step 11): trigger on bogos:discount-added only (never
  // bogos:cart-updated, which only starts BOGOS's work), 8 s window, safety
  // refresh at 3.5 s, at most two refreshes in total.
  var bogosWatch = null;
  function watchBogos() {
    if (bogosWatch) bogosWatch.stop();
    var count = 0;
    var discountDone = false;
    var safetyTimer = null;
    var endTimer = null;
    function run() {
      if (count >= 2) return;
      count += 1;
      refresh({ open: false });
    }
    function onDiscount() {
      if (discountDone) return;
      discountDone = true;
      if (safetyTimer) { clearTimeout(safetyTimer); safetyTimer = null; }
      run();
      stop();
    }
    function stop() {
      doc.removeEventListener('bogos:discount-added', onDiscount);
      if (safetyTimer) clearTimeout(safetyTimer);
      if (endTimer) clearTimeout(endTimer);
      safetyTimer = null;
      endTimer = null;
      if (bogosWatch === api) bogosWatch = null;
    }
    doc.addEventListener('bogos:discount-added', onDiscount);
    safetyTimer = setTimeout(function () { safetyTimer = null; run(); }, 3500);
    endTimer = setTimeout(stop, 8000);
    var api = { stop: stop };
    bogosWatch = api;
  }

  function cartError(msg, opts) {
    try {
      /* global publish, PUB_SUB_EVENTS */
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartError, { source: 'gbi', errors: msg });
      }
    } catch (e) { /* theme API changed */ }
    emit(doc, 'gbi:cart-error', { message: msg, source: opts.source, sectionId: opts.sectionId });
    return new Error(msg);
  }

  async function cartAdd(items, opts) {
    opts = opts || {};
    var list = mergeItems(items);
    if (!list.length) throw new Error(strings.cartError);

    var d = themeDrawer();
    var ids = sectionIdsFor(d);
    var url = (config.routes.cartAdd || '/cart/add') + '.js';
    var res, data;
    try {
      res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: list, sections: ids.join(','), sections_url: window.location.pathname })
      });
    } catch (e) {
      throw cartError(strings.cartError, opts);
    }
    try { data = await res.json(); } catch (e) { data = null; }
    if (!res.ok || !data || data.status) {
      var msg = (data && (data.description || data.message)) || strings.cartError;
      throw cartError(String(msg), opts);
    }

    if (typeof opts.beforeOpen === 'function') {
      try { await opts.beforeOpen(); } catch (e) { /* swallow */ }
    }

    var detail = { items: list, cart: data, source: opts.source, sectionId: opts.sectionId };

    if (!d || typeof d.renderContents !== 'function') {
      emit(doc, 'gbi:cart-added', detail);
      window.location.href = cartRoute();
      return data;
    }

    try {
      if (!data.sections) data.sections = await fetchSections(ids);
    } catch (e) {
      emit(doc, 'gbi:cart-added', detail);
      window.location.href = cartRoute();
      return data;
    }

    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gbi', cartData: data });
      }
    } catch (e) { /* theme API changed */ }

    try {
      if (typeof d.setActiveElement === 'function') d.setActiveElement(opts.opener || doc.activeElement);
      d.classList.remove('is-empty');
      d.renderContents(data);
    } catch (e) {
      emit(doc, 'gbi:cart-added', detail);
      window.location.href = cartRoute();
      return data;
    }

    watchBogos();
    guardDrawerFocus(d, 9000);
    emit(doc, 'gbi:cart-added', detail);
    return data;
  }

  /* ----------------------------------------------------------------- dialog */

  var states = new Map(); // dialog -> state (one open at a time, no stacking)
  var current = null;

  var FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, iframe, audio[controls], video[controls], [contenteditable]:not([contenteditable="false"]), [tabindex]:not([tabindex="-1"])';

  function visible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function focusables(el) {
    return Array.prototype.filter.call(el.querySelectorAll(FOCUSABLE), function (n) {
      return !n.closest('[hidden], [inert]') && visible(n);
    });
  }

  function focusEl(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (e2) { /* ignore */ } }
  }

  function initialFocus(el) {
    var target = el.querySelector('h1[tabindex="-1"], h2[tabindex="-1"], h3[tabindex="-1"], h4[tabindex="-1"], h5[tabindex="-1"], h6[tabindex="-1"]') ||
      el.querySelector('.gbi-sheet__close, [data-gbi-dialog-close]') ||
      focusables(el)[0];
    if (!target) {
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
      target = el;
    }
    focusEl(target);
  }

  function anyOpen() {
    var open = false;
    states.forEach(function (st, el) { if (el.open && !st.closing) open = true; });
    return open;
  }

  function panelOf(el) {
    return el.querySelector('.gbi-sheet__panel') || el.firstElementChild;
  }

  function wire(el, st) {
    st.onKeydown = function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        e.stopPropagation();
        close(el, { reason: 'esc' });
        return;
      }
      if (e.key === 'Tab') {
        var list = focusables(el);
        if (!list.length) { e.preventDefault(); focusEl(el); return; }
        var first = list[0];
        var last = list[list.length - 1];
        var active = doc.activeElement;
        if (e.shiftKey && (active === first || active === el || !el.contains(active))) {
          e.preventDefault();
          focusEl(last);
        } else if (!e.shiftKey && (active === last || !el.contains(active))) {
          e.preventDefault();
          focusEl(first);
        }
      }
    };
    st.onCancel = function (e) {
      e.preventDefault();
      close(el, { reason: 'esc' });
    };
    st.onPointerDown = function (e) { st.downTarget = e.target; };
    st.onClick = function (e) {
      if (e.target === el && st.downTarget === el) {
        close(el, { reason: 'overlay' });
        return;
      }
      var btn = e.target.closest && e.target.closest('.gbi-sheet__close, [data-gbi-dialog-close]');
      if (btn && el.contains(btn) && btn.closest('dialog') === el) {
        e.preventDefault();
        close(el, { reason: 'close' });
      }
    };
    st.onNativeClose = function () {
      // Closed by the browser (e.g. a close request we could not cancel): clean up.
      if (!st.closing) close(el, { reason: 'esc' });
    };
    el.addEventListener('keydown', st.onKeydown);
    el.addEventListener('cancel', st.onCancel);
    el.addEventListener('pointerdown', st.onPointerDown);
    el.addEventListener('click', st.onClick);
    el.addEventListener('close', st.onNativeClose);
    wireSwipe(el, st);
  }

  function unwire(el, st) {
    el.removeEventListener('keydown', st.onKeydown);
    el.removeEventListener('cancel', st.onCancel);
    el.removeEventListener('pointerdown', st.onPointerDown);
    el.removeEventListener('click', st.onClick);
    el.removeEventListener('close', st.onNativeClose);
    if (st.swipeOff) st.swipeOff();
  }

  // Swipe down on the handle or head (below 990 px) closes with reason 'swipe'.
  function wireSwipe(el, st) {
    var panel = panelOf(el);
    if (!panel) return;
    var startY = 0;
    var dy = 0;
    var active = false;
    var pid = null;
    function zone(target) {
      if (!target || !target.closest) return false;
      if (target.closest('button, a, input, select, textarea, [role="button"]')) return false;
      var z = target.closest('.gbi-sheet__handle, .gbi-sheet__head');
      return !!(z && el.contains(z));
    }
    function down(e) {
      if (mq.desktop.matches || e.button > 0 || !zone(e.target)) return;
      active = true;
      pid = e.pointerId;
      startY = e.clientY;
      dy = 0;
      panel.style.transition = 'none';
    }
    function move(e) {
      if (!active || e.pointerId !== pid) return;
      dy = Math.max(0, e.clientY - startY);
      panel.style.transform = 'translateY(' + dy + 'px)';
    }
    function up(e) {
      if (!active || (e && e.pointerId !== pid)) return;
      active = false;
      panel.style.transition = '';
      if (dy > 80) {
        if (!(mq.reduced && mq.reduced.matches)) panel.style.transform = 'translateY(100%)';
        close(el, { reason: 'swipe' });
      } else {
        panel.style.transform = '';
      }
      dy = 0;
    }
    el.addEventListener('pointerdown', down);
    window.addEventListener('pointermove', move, { passive: true });
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);
    st.swipeOff = function () {
      el.removeEventListener('pointerdown', down);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
      window.removeEventListener('pointercancel', up);
    };
  }

  function historyBack() {
    return new Promise(function (resolve) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        window.removeEventListener('popstate', finish);
        resolve();
      }
      window.addEventListener('popstate', finish);
      setTimeout(finish, 400);
      try { window.history.back(); } catch (e) { finish(); }
    });
  }

  var pendingOpen = new Map();

  function dialogOpen(el, opts) {
    if (!el || typeof el !== 'object') return Promise.resolve();
    if (pendingOpen.has(el)) return pendingOpen.get(el);
    var existing = states.get(el);
    if (el.open && existing && !existing.closing) return Promise.resolve(); // already open: no-op
    var p = doOpen(el, opts || {});
    pendingOpen.set(el, p);
    var clear = function () { if (pendingOpen.get(el) === p) pendingOpen.delete(el); };
    p.then(clear, clear);
    return p;
  }

  async function doOpen(el, opts) {
    var existing = states.get(el);

    var opener = opts.opener || null;
    if (!opener && doc.activeElement && doc.activeElement !== doc.body) opener = doc.activeElement;

    if (current && current !== el) {
      var other = current;
      var otherState = states.get(other);
      if (opener && other.contains(opener)) opener = otherState ? otherState.opener : null;
      await dialogClose(other, { reason: 'api', restoreFocus: false });
    }
    if (existing && existing.closingPromise) await existing.closingPromise;

    var st = { opener: opener, pushed: false, closing: false, opening: null, closingPromise: null, onPop: null };
    states.set(el, st);
    current = el;

    st.opening = (async function () {
      el.classList.remove('is-closing');
      try {
        if (!el.open) el.showModal();
      } catch (e) {
        el.setAttribute('open', '');
      }
      root.classList.add('gbi-lock');
      wire(el, st);
      void el.offsetWidth; // commit the start position before the enter motion
      el.classList.add('is-open');
      initialFocus(el);
      if (opts.history) {
        try {
          window.history.pushState({ gbiDialog: el.id || true }, '');
          st.pushed = true;
          st.onPop = function () {
            st.pushed = false;
            close(el, { reason: 'back' });
          };
          window.addEventListener('popstate', st.onPop);
        } catch (e) { st.pushed = false; }
      }
      await wait(slowMs());
      st.opening = null;
      emit(el, 'gbi:dialog-open', {});
    })();
    return st.opening;
  }

  function dialogClose(el, opts) {
    opts = opts || {};
    var st = el ? states.get(el) : null;
    if (!st) return Promise.resolve();
    if (st.closing) return st.closingPromise || Promise.resolve();
    var reason = opts.reason || 'api';
    var restoreFocus = Object.prototype.hasOwnProperty.call(opts, 'restoreFocus') ? !!opts.restoreFocus : reason !== 'added';
    st.closing = true;

    st.closingPromise = (async function () {
      if (st.opening) { try { await st.opening; } catch (e) { /* ignore */ } }
      var steps = [];
      if (st.onPop) window.removeEventListener('popstate', st.onPop);
      if (reason !== 'back' && st.pushed) {
        st.pushed = false;
        steps.push(historyBack());
      }
      var wasOpen = el.open;
      if (wasOpen) {
        el.classList.remove('is-open');
        el.classList.add('is-closing');
        steps.push(wait(slowMs()));
      }
      await Promise.all(steps);
      unwire(el, st);
      try { if (el.open) el.close(); } catch (e) { el.removeAttribute('open'); }
      el.classList.remove('is-closing', 'is-open');
      var panel = panelOf(el);
      if (panel) { panel.style.transform = ''; panel.style.transition = ''; }
      states.delete(el);
      if (current === el) current = null;
      if (!anyOpen()) root.classList.remove('gbi-lock');
      if (restoreFocus && st.opener && st.opener.isConnected) focusEl(st.opener);
      emit(el, 'gbi:dialog-close', { reason: reason });
    })();
    return st.closingPromise;
  }

  function close(el, opts) { return dialogClose(el, opts); }

  /* ------------------------------------------------------- shared drawer */

  var drawerEl = null;
  var CLOSE_SVG = '<svg class="gbi-icon gbi-icon--close" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function ensureDrawer() {
    if (drawerEl && drawerEl.isConnected) return drawerEl;
    drawerEl = doc.getElementById('GbiDrawer');
    if (!drawerEl) {
      drawerEl = doc.createElement('dialog');
      drawerEl.id = 'GbiDrawer';
      drawerEl.className = 'gbi gbi-sheet gbi-drawer';
      drawerEl.setAttribute('aria-labelledby', 'GbiDrawerTitle');
      drawerEl.innerHTML =
        '<div class="gbi-sheet__panel">' +
          '<span class="gbi-sheet__handle" aria-hidden="true"></span>' +
          '<header class="gbi-sheet__head">' +
            '<p class="gbi-sheet__label gbi-label" id="GbiDrawerLabel" hidden></p>' +
            '<h2 class="gbi-sheet__title" id="GbiDrawerTitle" tabindex="-1"></h2>' +
            '<button type="button" class="gbi-sheet__close">' + CLOSE_SVG + '</button>' +
          '</header>' +
          '<div class="gbi-sheet__body gbi-prose gbi-drawer__body"></div>' +
        '</div>';
      doc.body.appendChild(drawerEl);
    }
    bindSelect(drawerEl);
    return drawerEl;
  }

  function drawerOpen(o) {
    o = o || {};
    var d = ensureDrawer();
    var title = String(o.title || '').trim();
    var label = String(o.label || '').trim();
    var labelEl = d.querySelector('.gbi-sheet__label');
    var titleEl = d.querySelector('.gbi-sheet__title');
    var bodyEl = d.querySelector('.gbi-sheet__body');
    var closeEl = d.querySelector('.gbi-sheet__close');
    if (labelEl) {
      labelEl.textContent = label;
      // The mono label repeats nothing: hidden when empty or equal to the title.
      labelEl.hidden = !label || label.toLowerCase() === title.toLowerCase();
    }
    if (titleEl) titleEl.textContent = title || label;
    if (bodyEl) { bodyEl.innerHTML = o.html || ''; bodyEl.scrollTop = 0; }
    if (closeEl) closeEl.setAttribute('aria-label', strings.close);
    countUp(d);
    return dialogOpen(d, { opener: o.opener || null, history: true });
  }

  function drawerClose() {
    if (!drawerEl) return Promise.resolve();
    return dialogClose(drawerEl, { reason: 'api' });
  }

  /* ------------------------------------------------ details -> drawer */

  doc.addEventListener('click', function (e) {
    var summary = e.target && e.target.closest ? e.target.closest('summary') : null;
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;
    if (details.querySelector('summary') !== summary) return;
    if (!details.hasAttribute('data-gbi-drawer') && !details.hasAttribute('data-gbi-track')) return;

    var opening = !details.open;
    if (details.hasAttribute('data-gbi-drawer') && mq.desktop.matches) {
      e.preventDefault();
      if (details.open) details.open = false;
      var titleEl = summary.querySelector('[data-gbi-drawer-title]');
      var bodyEl = details.querySelector('[data-gbi-drawer-body]');
      drawerOpen({
        label: details.dataset.gbiDrawerLabel || '',
        title: (titleEl ? titleEl.textContent : summary.textContent || '').trim(),
        html: bodyEl ? bodyEl.innerHTML : '',
        opener: summary
      });
      opening = true;
    }
    if (opening && details.dataset.gbiTrack) {
      track(details.dataset.gbiTrack, { key: details.dataset.gbiTrackKey || '' });
    }
  });

  /* ------------------------------------- link -> open a details row (v3 §2.6.2) */

  doc.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('[data-gbi-open-details]') : null;
    if (!link) return;
    var key = link.getAttribute('data-gbi-open-details') || '';
    if (!key) return;
    var details = doc.getElementById('gbi-details-' + key);
    if (!details || details.tagName !== 'DETAILS') return;   // let the anchor's default run
    e.preventDefault();
    details.open = true;
    var reduced = mq.reduced && mq.reduced.matches;
    try {
      details.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
    } catch (err) { details.scrollIntoView(true); }
    var summary = details.querySelector('summary');
    if (summary) {
      try { summary.focus({ preventScroll: true }); } catch (err) { summary.focus(); }
    }
    track('details_open', { key: key, from: 'inbox' });
  });

  /* ---------------------------------------------------------- count-up */

  function formatCount(value, fmt) {
    var n = Math.round(value);
    if (fmt === 'number') return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return String(n);
  }

  var countIO = null;
  var nearIO = null;

  function animateCount(el) {
    if (el.__gbiCountDone) return;
    el.__gbiCountDone = true;
    if (countIO) countIO.unobserve(el);
    if (nearIO) nearIO.unobserve(el);
    var target = parseFloat(el.getAttribute('data-gbi-count'));
    var fmt = el.getAttribute('data-gbi-count-format');
    if (!isFinite(target) || (mq.reduced && mq.reduced.matches)) {
      if (isFinite(target)) el.textContent = formatCount(target, fmt);
      return;
    }
    var start = null;
    var DUR = 900;
    el.textContent = formatCount(0, fmt);
    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / DUR);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = formatCount(target * eased, fmt);
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = formatCount(target, fmt);
    }
    requestAnimationFrame(frame);
  }

  function ensureObservers() {
    if (countIO || !('IntersectionObserver' in window)) return;
    countIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && en.intersectionRatio >= 0.4) animateCount(en.target);
      });
    }, { threshold: [0.4] });
    nearIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var el = en.target;
        // Near the viewport and still below it: zero it just before the count.
        if (en.isIntersecting && !el.__gbiCountDone && en.boundingClientRect.top > 0 && !el.__gbiCountZeroed) {
          el.__gbiCountZeroed = true;
          el.textContent = formatCount(0, el.getAttribute('data-gbi-count-format'));
        }
      });
    }, { rootMargin: '0px 0px 160px 0px', threshold: 0 });
  }

  function countUp(rootEl) {
    var scope = rootEl && rootEl.querySelectorAll ? rootEl : doc;
    var list = scope.querySelectorAll('[data-gbi-count]');
    if (!list.length) return;
    var reduced = mq.reduced && mq.reduced.matches;
    ensureObservers();
    Array.prototype.forEach.call(list, function (el) {
      if (el.__gbiCountInit) return;
      el.__gbiCountInit = true;
      if (reduced || !countIO) {
        var v = parseFloat(el.getAttribute('data-gbi-count'));
        if (isFinite(v)) el.textContent = formatCount(v, el.getAttribute('data-gbi-count-format'));
        el.__gbiCountDone = true;
        return;
      }
      nearIO.observe(el);
      countIO.observe(el);
    });
  }

  /* ------------------------------------------------ text selection */

  var selectBound = new WeakSet();
  function stopSelect(e) { e.stopPropagation(); }
  function bindSelect(el) {
    if (!el || selectBound.has(el)) return;
    selectBound.add(el);
    el.addEventListener('selectstart', stopSelect);
  }
  function bindSelectAll(scope) {
    var s = scope && scope.querySelectorAll ? scope : doc;
    if (s.classList && s.classList.contains('gbi')) bindSelect(s);
    Array.prototype.forEach.call(s.querySelectorAll('.gbi'), bindSelect);
  }

  /* ------------------------------------------------------------- API */

  var GBI = window.GBI || {};
  Object.assign(GBI, {
    config: config,
    strings: strings,
    mq: mq,
    t: t,
    handleize: handleize,
    money: { format: formatMoney },
    track: track,
    onIdle: onIdle,
    cart: {
      add: cartAdd,
      refresh: refresh,
      get: cartGet,
      kitsIn: kitsIn
    },
    dialog: {
      open: dialogOpen,
      close: dialogClose
    },
    drawer: {
      open: drawerOpen,
      close: drawerClose
    },
    countUp: countUp
  });
  window.GBI = GBI;

  /* ------------------------------------------------------------ init */

  function init(scope) {
    loadConfig();
    bindSelectAll(scope || doc);
    countUp(scope || doc);
  }

  init(doc);

  doc.addEventListener('shopify:section:load', function (e) {
    init(e.target && e.target.querySelectorAll ? e.target : doc);
  });
})();
